import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ClusterActions from './cluster.actions';
import { ClusterService } from '../../services/cluster.service';

@Injectable()
export class ClusterEffects {
  loadCluster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClusterActions.loadCluster),
      exhaustMap((_) =>
        this.clusterService.getCluster().pipe(
          map((data) => ClusterActions.loadClusterSuccess({ cluster: data })),
          catchError((error) =>
            of(ClusterActions.loadClusterFailure({ error }))
          )
        )
      )
    )
  );

  addCluster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClusterActions.addCluster),
      concatMap(({ newCluster }) =>
        this.clusterService.createCluster(newCluster).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return ClusterActions.addClusterSuccess({
              newCluster: data,
            });
          }),
          catchError((error) =>
            of(ClusterActions.addClusterFailure({ error: error.error.message }))
          )
        )
      )
    )
  );

  updateCluster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClusterActions.updateCluster),
      map((action) => action.updateCluster),
      concatMap((updateCluster) =>
        this.clusterService.updateCluster(updateCluster).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return ClusterActions.updateClusterSuccess({
              updateCluster: updateCluster,
            });
          }),
          catchError((error) =>
            of(ClusterActions.updateClusterFailure({ error: error.message }))
          )
        )
      )
    )
  );

  removeCluster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClusterActions.removeCluster),
      map((action) => action.ids),
      concatMap((ids) =>
        this.clusterService.deleteCluster(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ClusterActions.removeClusterSuccess({ ids });
          }),
          catchError((error) =>
            of(ClusterActions.updateClusterFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private clusterService: ClusterService,
    private notification: NotificationService
  ) {}
}
